<h2 mat-dialog-title>{{ 'New Offer' | translate }}</h2>
<mat-dialog-content>
  <div class="cdc-form-field actif">
    <div class="cdc-label">{{ 'Name' | translate }}</div>
    <input matInput type="text" [(ngModel)]="name">
  </div>
  <div class="cdc-form-field actif" [ngClass]="{'actif': !codeExists, 'error': updated && (codeExists || isEmptyCode)}">
    <div class="cdc-label">{{ "Code" | translate }}</div>
    <input matInput type="text" [(ngModel)]="code" (ngModelChange)="onChangeCode()">
    <mat-error [ngClass]="{'hidden':!codeExists}">{{ 'The code already exists.' | translate }}</mat-error>
    <mat-error [ngClass]="{'hidden':!isEmptyCode}">{{ 'Cannot be empty.' | translate }}</mat-error>
  </div>
  <div class="cdc-form-field actif">
    <div class="cdc-label">{{ 'Expiration delay' | translate }} ({{ "hours" | translate }})</div>
    <input matInput type="number" min="0" [(ngModel)]="expirationDelay"
      (focusout)="expirationDelay = ((expirationDelay != null && expirationDelay != undefined && expirationDelay < 0) ? 0 : expirationDelay)">
  </div>
  <div class="cdc-form-field actif">
    <mat-checkbox [(ngModel)]="isRequired">
      {{ 'Required' | translate }}
    </mat-checkbox>
  </div>
  <div class="cdc-form-field actif">
    <mat-checkbox [(ngModel)]="hidden">
      {{ 'Single route' | translate }}
    </mat-checkbox>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'Cancel' | translate }}</button>
  <button mat-button color="primary" (click)="onConfirm()" [disabled]="codeExists || isEmptyCode || !updated">{{ 'Confirm' | translate }}</button>
</mat-dialog-actions>
